import { z as zod } from "zod";

export const TicketTierOnlineSchema = zod
	.object({
		id: zod.string().optional(),
		name: zod.string().optional(),
		limitAudiences: zod
			.number({
				message: "Vui lòng nhập số lượng người tối đa của sự kiện",
			})
			.optional(),
		limitTicketPerUser: zod
			.number({
				message: "Vui lòng nhập số vé tối đa/user của sự kiện",
			})
			.optional(),
		farePrice: zod
			.number({ message: "Vui lòng nhập giá vé của sự kiện" })
			.max(999999999, { message: "Giá vé vượt quá quy định" }),
		isFree: zod.coerce.boolean(),
		isUnlimitedAudiences: zod.coerce.boolean(),
		isUnlimitedTicketPerUser: zod.coerce.boolean(),
		description: zod
			.string()
			.max(1000, { message: "Mô tả hạng vé không được vượt quá 1000 ký tự" })
			.optional(),
		address: zod.string().optional(),
		hasBeenPaid: zod.boolean().optional(),
	})
	.refine(
		(data) => {
			return data.isFree || data.farePrice > 0;
		},
		{
			message: "Giá vé phải lớn hơn 0",
			path: ["farePrice"],
		},
	)
	.refine(
		(data) => {
			return (
				data.isUnlimitedAudiences ||
				(Number.isInteger(data.limitAudiences) &&
					(data.limitAudiences || 0) > 0)
			);
		},
		{
			message: "Số người tối đa phải lớn hơn 0",
			path: ["limitAudiences"],
		},
	)
	.refine(
		(data) => {
			return (
				typeof data.limitTicketPerUser === "undefined" ||
				data.isUnlimitedTicketPerUser ||
				(Number.isInteger(data.limitTicketPerUser) &&
					(data.limitTicketPerUser || 0) > 0)
			);
		},
		{
			message: "Số vé tối đa/user phải lớn hơn 0",
			path: ["limitTicketPerUser"],
		},
	);

export const TicketTierOfflineSchema = zod
	.object({
		id: zod.string().optional(),
		name: zod
			.string({
				message: "Vui lòng nhập tên loại vé",
			})
			.min(1, { message: "Vui lòng nhập tên loại vé" })
			.max(100, { message: "Tên loại vé không được vượt quá 100 ký tự" }),
		limitAudiences: zod
			.number({
				message: "Vui lòng nhập số lượng người tối đa của sự kiện",
			})
			.optional(),
		limitTicketPerUser: zod
			.number({
				message: "Vui lòng nhập số vé tối đa/user của sự kiện",
			})
			.optional(),
		farePrice: zod
			.number({ message: "Vui lòng nhập giá vé của sự kiện" })
			.max(999999999, { message: "Giá vé vượt quá quy định" })
			.optional(),
		isFree: zod.coerce.boolean(),
		isUnlimitedAudiences: zod.coerce.boolean(),
		isUnlimitedTicketPerUser: zod.coerce.boolean(),
		description: zod
			.string()
			.max(1000, { message: "Mô tả hạng vé không được vượt quá 1000 ký tự" })
			.optional(),
		address: zod.string().optional(),
		hasBeenPaid: zod.boolean().optional(),
	})
	.refine(
		(data) => {
			return data.isFree || (data?.farePrice || 0) > 0;
		},
		{
			message: "Giá vé phải lớn hơn 0",
			path: ["farePrice"],
		},
	)
	.refine(
		(data) => {
			return (
				data.isUnlimitedAudiences ||
				(Number.isInteger(data.limitAudiences) &&
					(data.limitAudiences || 0) > 0)
			);
		},
		{
			message: "Số người tối đa phải lớn hơn 0",
			path: ["limitAudiences"],
		},
	)
	.refine(
		(data) => {
			return (
				data.isUnlimitedTicketPerUser ||
				(Number.isInteger(data.limitTicketPerUser) &&
					(data.limitTicketPerUser || 0) > 0)
			);
		},
		{
			message: "Số vé tối đa/user phải lớn hơn 0",
			path: ["limitTicketPerUser"],
		},
	);
